<template>
  <div
    class="button-window-container"
    :class="{ open: isOpen, fixed: isFixed }"
  >
    <missing-permissions-tooltip
      :missing-permissions-list="
        listMissingPermissions ? listMissingPermissions : []
      "
    >
      <div
        class="button-container"
        :class="{ disabled: isFixed || disabled }"
        @click="toggleWindow"
      >
        <slot name="buttonIcon" />

        <template v-if="isOpen">
          <span style="margin-left: 25px; text-align: left">
            {{ windowName }}
          </span>
          <dev-tag
            v-if="dev"
            position="relative"
            :style="{ 'margin-left': '15px' }"
          />
        </template>

        <v-spacer />
        <slot v-if="isOpen" name="refreshButton" />
      </div>
    </missing-permissions-tooltip>

    <div v-show="isOpen" class="window-content-container">
      <hr class="home-window-hr" />
      <slot name="windowContent" />
    </div>
  </div>
</template>

<script>
import DevTag from "@/components/_Atoms/DevTag";
import MissingPermissionsTooltip from "@/components/_Atoms/MissingPermissionsTooltip";

export default {
  name: "NetworkDiagramButtonWindow",

  components: { MissingPermissionsTooltip, DevTag },

  props: {
    /**
     * Label of the button/window
     */
    windowName: {
      type: String,
      required: true
    },
    /**
     * If the button/window is still in development or not
     */
    dev: {
      type: Boolean,
      default: false
    },
    /**
     * If the window is supposed to open and close or be always open.
     */
    isFixed: {
      type: Boolean,
      default: false
    },
    /**
     * If the parent changes the state of the button/window
     */
    parentToggleWindow: {
      type: Boolean
    },

    disabled: {
      type: Boolean,
      default: false
    },

    listMissingPermissions: Array
  },

  data() {
    return {
      /** State of the Starting Point window: true = open; false = minimized. */
      isOpen: false
    };
  },
  created() {
    if (this.isFixed) this.isOpen = true;
  },
  methods: {
    toggleWindow() {
      if (
        !this.isFixed &&
        !this.disabled &&
        (!this.listMissingPermissions ||
          this.listMissingPermissions.length === 0)
      ) {
        this.isOpen = !this.isOpen;
        this.$emit("toggleWindow", this.isOpen);
      }
    }
  },
  watch: {
    parentToggleWindow(newValue) {
      this.isOpen = newValue;
    }
  }
};
</script>

<style scoped>
.button-window-container {
  width: fit-content;
  margin: 20px;
  background-color: white;
  box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.08);
  border-radius: 2px;
  padding: 10px;
  color: var(--secondary-darker);
}
.button-window-container.fixed {
  box-shadow: none;
  margin: 0;
}

.button-window-container.open {
  width: 250px;
}

.button-window-container.open.fixed {
  width: 100%;
}

.button-container {
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.button-container.disabled {
  cursor: inherit;
}
.window-content-container {
  margin-top: 5px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Network/NetworkButtonWindow.vue